package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.css.boxShadow
import com.varabyte.kobweb.compose.css.overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.outline
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent

val AboutHeroSectionStyle = CssStyle {
    base {
        Modifier
            .color(HLDITheme.Colors.white)
            .textAlign(TextAlign.Center)
            .position(Position.Relative) // anchors the wave SVG below
            .styleModifier {
                property(
                    "background",
                    "linear-gradient(135deg, ${HLDITheme.Colors.primary} 0%, ${HLDITheme.Colors.secondary} 100%)"
                )
            }
    }
}

val AboutHeroTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(48.px)
            .fontFamily("Playfair Display", "serif")
            .margin(bottom = 16.px)
    }
}

val AboutHeroTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(18.px)
            .opacity(0.95)
            .maxWidth(600.px)
            .margin(0.px, autoLength)
    }
}
val SpinKeyframes = Keyframes {
    0.percent {
        Modifier.rotate(0.deg)
    }

    25.percent {
        Modifier.rotate(90.deg)
    }

    50.percent {
        Modifier.rotate(180.deg)
    }

    75.percent {
        Modifier.rotate(270.deg)
    }

    100.percent {
        Modifier.rotate(360.deg)
    }
}
val SpinnerStyle = CssStyle {
    base {
        Modifier
            .borderRadius(50.percent)
            .animation(
                SpinKeyframes.toAnimation(
                    duration = 1.s,
                    timingFunction = AnimationTimingFunction.Linear,
                    iterationCount = AnimationIterationCount.Infinite
                )
            )
            .styleModifier {
                property("border", "4px solid #e5e7eb")
                property("border-top", "4px solid ${HLDITheme.Colors.primary}")
            }
    }
}